import {HttpContextToken} from '@angular/common/http';

/** Let a dialog display actionable errors without the global snackbar/403 redirect. */
export const HANDLE_HTTP_ERRORS_LOCALLY = new HttpContextToken<boolean>(() => false);
